import { createSelector } from 'reselect'

import type { GlobalState } from '../types'
import type { FilesByStatus } from './types'

const selectFiles = (state: GlobalState) => state.upload.files
const selectIdentity = (state: GlobalState) => state.form.identityForm

const getFilesByStatus = createSelector(
  selectFiles,
  files => {
    return files.reduce<FilesByStatus>((acc, curr) => {
      if (!curr.error) {
        return {
          ...acc,
          successes: [
            ...acc.successes,
            {
              fileName: curr.file.name,
              fileSize: curr.file.size,
              trackingId: curr.trackingId,
              batchId: curr.batchId
            }
          ]
        }
      }

      switch(curr.error.message) {
        case '400':
          return {
            ...acc,
            unsupportedErrors: [
              ...acc.unsupportedErrors,
              {
                fileName: curr.file.name,
                fileSize: curr.file.size,
                trackingId: curr.trackingId,
                batchId: curr.batchId
              }
            ]
          }
        case '0':
          return {
            ...acc,
            lostConnectionErrors: [
              ...acc.lostConnectionErrors,
              {
                fileName: curr.file.name,
                fileSize: curr.file.size,
                trackingId: curr.trackingId,
                batchId: curr.batchId
              }
            ]
          }
        default:
          return {
            ...acc,
            networkErrors: [
              ...acc.networkErrors,
              {
                fileName: curr.file.name,
                fileSize: curr.file.size,
                trackingId: curr.trackingId,
                batchId: curr.batchId
              }
            ]
          }
      }
    }, { successes: [], unsupportedErrors: [], networkErrors: [], lostConnectionErrors: [] })
  }
)

const getIdentityValues = createSelector(
  selectIdentity,
  identity => ({
    name: identity ? identity.values?.identityName : '',
    email: identity ? identity.values?.identityEmail : '',
    role: identity ? identity.values?.roleInClaim : '',
  })
)

export {
  getFilesByStatus,
  getIdentityValues
}
